
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDOeL2jPYXxvgSiX6xWCI3-QMI1RN0CKG4",
  authDomain: "libooking-7f627.firebaseapp.com",
  projectId: "libooking-7f627",
  storageBucket: "libooking-7f627.firebasestorage.app",
  messagingSenderId: "799956672304",
  appId: "1:799956672304:web:e15397678ff5dd99d4f2f5",
  measurementId: "G-E9TD89PQLK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const messaging = getMessaging(app);
//"site": "libooking-7f627-90d68",
//firebase deploy --only hosting:libooking-7f627-90d68